/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StringResources from 'nls/StringResources';
import {
	Dialog,
	FlexItem,
	FlexLayout,
	Checkbox
} from '@ba/ba-ui-carbon-toolkit';
import '../../../stylesheets/all.scss';

export default class ConfirmReplaceDialog extends Component {
	static propTypes = {
		sourceName: PropTypes.string.isRequired,
		isApplyToAll: PropTypes.bool.isRequired,
		okCallback: PropTypes.func.isRequired,
		cancelCallback: PropTypes.func.isRequired
	};

	constructor(props) {
		super(props);

		this.state = {
			isApplyToAll: this.props.isApplyToAll
		};
	}

	_replace = () => {
		this.props.okCallback( this.state.isApplyToAll );
	}

	_cancel = () => {
		this.props.cancelCallback( this.state.isApplyToAll );
	}

	render () {
		return (
			<Dialog width='500px' onClose={this._cancel} startingFocusIndex={0}>
				<Dialog.Header>{StringResources.get('schematicsReplaceDlgTitle')}</Dialog.Header>
				<Dialog.Body>
					<div style={{ marginTop: '8px' }}>
						{StringResources.get( 'schematicsReplaceDlgContent', { 'sourceName': this.props.sourceName } )}
					</div>
					<FlexLayout
						direction='column'
						width='100%'
						height='100%'
						alignItems='flex-start'
						justifyContent='center'
						style={{ marginTop: '8px' }}
					>
						<FlexItem>
							<Checkbox
								label={StringResources.get('schematicsReplaceDlgApplyToAllFiles')}
								checked={this.state.isApplyToAll}
								onChange={ () => this.setState( { isApplyToAll: !this.state.isApplyToAll } ) }
							/>
						</FlexItem>
					</FlexLayout>
				</Dialog.Body>
				<Dialog.Footer>
					<Dialog.Button id='idCancelBtn' label={StringResources.get('cancelDialog')} onClick={this._cancel} tabIndex={0} />
					<Dialog.Button id='idOkBtn' label={StringResources.get('okDialog')} onClick={this._replace} tabIndex={0} primary/>
				</Dialog.Footer>
			</Dialog>
		);
	}
}



// WEBPACK FOOTER //
// ./src/js/dialog/schematic/ConfirmReplaceDialog.js